import React, { Component } from "react";
import { EditHeadComponent } from "./../BioAndSubEditComponent";
import { connect } from "react-redux";
import { Col, Row, Modal } from "react-bootstrap";
import {
  EducationAndWorkPanel,
  EditEducationAndWorkPanel,
} from "./../../TutorSetting/BioAndSubEditComponent";
import { TutorSettingAction } from "./../../../redux/actions";
import ConfirmationModal from "./../../../components/modals/ConfirmationModal";
import { updateTutorSettings } from "../../../apis/tutors";

class WorkSetting extends Component {
  constructor() {
    super();
    this.state = {
      editMode: "",
      tutorSettingDataState: {},
      EditSpecificWork: {
        employerName: "",
        endDate: "",
        startDate: "",
        jobTitle: "",
        isCurrentJob: false,
      },
    };
  }

  componentDidMount = () => {
    const { tutorSettingData } = this.props;
    var WorkData = { ...tutorSettingData };
    WorkData = WorkData?.tutorDetails?.employment?.sort(function (a, b) {
      return new Date(b.startDate) - new Date(a.startDate);
    });
    this.setState({
      tutorSettingDataState: tutorSettingData,
      WorkData: WorkData?.length ? WorkData : [],
    });
  };
  componentDidUpdate = (prevProps) => {
    const { tutorSettingData } = this.props;
    const { tutorSettingDataState } = this.state;
    if (
      (!tutorSettingDataState?.userId && tutorSettingData?.userId) ||
      prevProps?.tutorSettingData?.userId !== tutorSettingData?.userId
    ) {
      var WorkData = { ...tutorSettingData };
      WorkData = WorkData?.tutorDetails?.employment?.sort(function (a, b) {
        return new Date(b.startDate) - new Date(a.startDate);
      });
      this.setState({
        tutorSettingDataState: tutorSettingData,
        WorkData: WorkData?.length ? WorkData : [],
      });
    }
  };

  onCurrent = (index, rollStatus) => {
    const { EditSpecificWork } = this.state;
    return (
      (EditSpecificWork[rollStatus] = !EditSpecificWork[rollStatus]),
      this.setState({
        EditSpecificWork,
      })
    );
  };

  onTextChange = (e, add) => {
    const { EditSpecificWork } = this.state;
    EditSpecificWork[e.target.name] = e.target.value;
    this.setState({
      EditSpecificWork,
      [`${add ? add : ""}${[e.target.name]}Req`]: true,
    });
  };
  onChangeDate = (date, index, dateType, add) => {
    const { EditSpecificWork } = this.state;
    EditSpecificWork[dateType] = date;
    this.setState({
      EditSpecificWork,
      [`${add ? add : ""}${[dateType]}Req`]: true,
    });
  };
  onSave = (index) => {
    let { tutorSettingData } = this.props;
    let { WorkData, EditSpecificWork } = this.state;
    WorkData[index] = EditSpecificWork;
    tutorSettingData.tutorDetails.employment = WorkData;
    this.props.TutorSettingStoreData(tutorSettingData);
    let updateSettingParam = {
      updateSetting: {
        employment: WorkData,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
    this.setState({
      selectedIndex: "",
    });
  };
  onCancel = () => {
    const { tutorSettingData } = this.props;
    console.log(tutorSettingData?.tutorDetails?.employment, "====");

    var WorkData = tutorSettingData?.tutorDetails?.employment.sort(function (
      a,
      b
    ) {
      return new Date(b.startDate) - new Date(a.startDate);
    });
    this.setState({
      WorkData,
      selectedIndex: "",
    });
  };
  onRemove = (index) => {
    let { tutorSettingData } = this.props;
    tutorSettingData.tutorDetails.employment.splice(index, 1);
    this.props.TutorSettingStoreData(tutorSettingData);
    let updateSettingParam = {
      updateSetting: {
        employment: tutorSettingData.tutorDetails.employment,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
    this.setState({
      selectedIndex: "",
      confirmShow: false,
    });
  };

  AddWorkObj = () => {
    let { tutorSettingData } = this.props;
    let { WorkData, EditSpecificWork } = this.state;
    WorkData.push(EditSpecificWork);
    tutorSettingData.tutorDetails.employment = WorkData;
    this.props.TutorSettingStoreData(tutorSettingData);
    let updateSettingParam = {
      updateSetting: {
        employment: WorkData,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
    this.setState({
      selectedIndex: "",
      isOpen: false,
    });
  };
  render() {
    const {
      EditSpecificWork,
      selectedIndex,
      isOpen,
      WorkData,
      confirmShow,
      employerNameReq,
      jobTitleReq,
      addemployerNameReq,
      addjobTitleReq,
      startDateReq,
      endDateReq,
      addstartDateReq,
      addendDateReq,
    } = this.state;
    let WorkArr = [
      {
        head: "Askademia Limited",
        value: "CEO, 02/2020-present",
      },
      ,
      {
        head: "SSp Health Limited",
        value: "Finance, 02/2020-present",
      },
    ];
    return (
      <div className="flex-col-center">
        <EditHeadComponent
          settingTitle={"Work experiance"}
          settingDescription={
            "Add work experiance revlevant to your taught subjects"
          }
          buttonTitle={"Add work"}
          backToprofileView={() => this.props.history.goBack()}
          goTobutton={() =>
            this.setState({
              isOpen: true,
              EditSpecificWork: {
                employerName: "",
                endDate: "",
                startDate: "",
                jobTitle: "",
                isCurrentJob: false,
              },
            })
          }
        />
        <Col
          lg={9}
          md={9}
          sm={12}
          xs={12}
          className="ProfileBio-of-setting-div"
        >
          <div style={{ marginBottom: "20px" }} />
          {WorkData?.length
            ? WorkData.map((work, i) => (
                <div>
                  {selectedIndex === i &&
                  EditSpecificWork.hasOwnProperty("employerName") ? (
                    <EditEducationAndWorkPanel
                      firstInputHeadTitle="Company / Orgnization name"
                      secondInputHeadTitle="Your role"
                      roleText="I am currently working at this company"
                      EditSpecificEduAndWork={EditSpecificWork}
                      firstInputName="employerName"
                      secondInputName="jobTitle"
                      firstInputReq={employerNameReq}
                      secondInputReq={jobTitleReq}
                      startDateReq={startDateReq}
                      endDateReq={endDateReq}
                      firstInputError={"Add Company / Orgnization name"}
                      secondInputError={"Add role"}
                      current="isCurrentJob"
                      onCurrent={this.onCurrent}
                      onTextChange={this.onTextChange}
                      onChangeDate={this.onChangeDate}
                      index={i}
                      onCancel={this.onCancel}
                      onSave={this.onSave}
                      onRemove={() =>
                        this.setState({
                          confirmShow: true,
                        })
                      }
                      style={{
                        height: "65px",
                      }}
                    />
                  ) : (
                    <EducationAndWorkPanel
                      onEdit={() =>
                        this.setState({
                          EditSpecificWork: { ...work },
                          selectedIndex: i,
                        })
                      }
                      selectedIndex={selectedIndex}
                      head={`${work.employerName ? work.employerName : ""} . ${
                        work?.jobTitle ? work?.jobTitle : ""
                      }`}
                      value={`${
                        work.startDate
                          ? new Date(work.startDate).getFullYear()
                          : ""
                      } - ${
                        work.isCurrentJob
                          ? "present"
                          : work.endDate
                          ? new Date(work.endDate).getFullYear()
                          : ""
                      }`}
                    />
                  )}
                </div>
              ))
            : ""}
        </Col>
        <div style={{ marginBottom: "50px" }} />
        <AddWorkModal
          isOpen={isOpen}
          onHide={() =>
            this.setState({
              isOpen: false,
            })
          }
          EditSpecificWork={EditSpecificWork}
          onCurrent={this.onCurrent}
          onTextChange={(e) => this.onTextChange(e, "add")}
          onChangeDate={(date, index, dateType) =>
            this.onChangeDate(date, index, dateType, "add")
          }
          firstInputReq={addemployerNameReq}
          secondInputReq={addjobTitleReq}
          startDateReq={addstartDateReq}
          endDateReq={addendDateReq}
          onCancel={this.onCancel}
          AddWorkObj={this.AddWorkObj}
        />
        <ConfirmationModal
          confirmShow={confirmShow}
          confirmonHide={() =>
            this.setState({
              confirmShow: false,
            })
          }
          onRemove={this.onRemove}
          modalMessage={"Are you sure you want to remove this Work?"}
        />
      </div>
    );
  }
}

const AddWorkModal = ({
  isOpen,
  onHide,
  EditSpecificWork,
  onCurrent,
  onTextChange,
  onChangeDate,
  onCancel,
  AddWorkObj,
  firstInputReq,
  secondInputReq,
  startDateReq,
  endDateReq,
}) => {
  return (
    <div>
      <Modal
        size="lg"
        className="ProfileStatus-modal"
        show={isOpen}
        onHide={onHide}
      >
        <Modal.Body>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ padding: "10px 40px", textAlign: "justify" }}
            >
              <div
                className="cancel-btn flex-center-center"
                onClick={onHide}
                style={{
                  fontSize: "17px",
                  width: "30px",
                  height: "30px",
                  marginTop: "20px",
                }}
              >
                <i className="mdi mdi-close"></i>
              </div>
              <div style={{ marginBottom: "50px" }} />
              <h4
                style={{
                  color: "#0f0f0f",
                  fontSize: "24px",
                  fontFamily: "CircularStd",
                }}
              >
                Add work experience
              </h4>
              <div style={{ marginBottom: "10px" }} />
              <EditEducationAndWorkPanel
                firstInputHeadTitle="Company / Orgnization name"
                secondInputHeadTitle="Your role"
                roleText="I am currently working at this company"
                EditSpecificEduAndWork={EditSpecificWork}
                firstInputName="employerName"
                secondInputName="jobTitle"
                current="isCurrentJob"
                firstInputReq={firstInputReq}
                secondInputReq={secondInputReq}
                startDateReq={startDateReq}
                endDateReq={endDateReq}
                firstInputError={"Add Company / Orgnization name"}
                secondInputError={"Add role"}
                onCurrent={onCurrent}
                onTextChange={onTextChange}
                onChangeDate={onChangeDate}
                onCancel={onCancel}
                AddObj={AddWorkObj}
                style={{
                  head: {
                    fontSize: "16px",
                    fontWeight: "400",
                  },
                  height: "45px",
                }}
                Addbtn={"Add"}
                ismodal={true}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingData },
  } = state;
  return {
    tutorSettingData,
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(WorkSetting);
